export default {
  body: {
    id: 'payment_form_adornment_paypal_body',
    defaultMessage:
      'You can pay upfront, with interest-free pay-in-4, or monthly installments with PayPal. We’ll send you to their site to finish the payment.',
  },
}
